export const MODAL_DIALOG_GUTTER = {
  xs: 8,
  md: 10,
  xl: 12
};
export const MODAL_CLOSE_BUTTON_SIZE = 56;
export const MODAL_CLOSE_CIRCLE_BUTTON_PADDING = 16;
export const MODAL_HORIZONTAL_PADDING = {
  xs: '24px',
  xl: '32px'
};
export const MODAL_VERTICAL_PADDING = {
  xs: '14px',
  sm: '16px',
  md: '20px',
  xl: '24px'
};
export const MODAL_BODY_VERTICAL_PADDING = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  xl: '28px'
};
export const MODAL_WIDTH = {
  xs: '100%',
  sm: '496px',
  md: '680px',
  lg: '744px',
  xl: '840px'
};
export const MODAL_DIALOG_WIDTH = {
  xs: '100%',
  sm: '496px',
  md: '640px',
  lg: '680px',
  xl: '744px'
};